'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { GROQImage } from '@/sanity/lib/types';
import icon from '@/public/global/chipIcon.svg';
// import iconGray from "@/public/global/chipIconGray.svg";
import BrailleSpinner, {
  type SpinnerVariant,
} from '@/components/global/ui/BrailleSpinner';

export default function Chip({
  text,
  className = '',
  variantGray,
  animatedIcon,
  spinnerVariant = 'magnify',
  spinnerColor = '#FF5500',
  spinnerSize = 24,
  spinnerFps,
  spinnerDotScale,
}: {
  text: string;
  className?: string;
  variantGray?: boolean;
  animatedIcon?: boolean;
  spinnerVariant?: SpinnerVariant;
  spinnerColor?: string;
  spinnerSize?: number;
  spinnerFps?: number;
  spinnerDotScale?: number;
}) {
  if (!text) return null;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-[1.25rem] m-0 prose-p:text-black prose-p:uppercase prose-p:text-[2rem] prose-p:font-spacemono prose-p:m-0',
        className,
      )}
    >
      {animatedIcon ? (
        <BrailleSpinner
          variant={spinnerVariant}
          size={spinnerSize}
          fps={spinnerFps}
          dotScale={spinnerDotScale}
          color={spinnerColor}
        />
      ) : (
        <div className="flex items-center gap-[0.375rem]">
          <div className="h-[1.5rem] bg-[#FF5500] animate-chip-bar" />
          <div className="h-[1.5rem] bg-[#FF5500] animate-chip-bar [animation-delay:-1.333s]" />
          <div className="h-[1.5rem] bg-[#FF5500] animate-chip-bar [animation-delay:-0.667s]" />
        </div>
      )}

      <p className="">{text}</p>

      {/* {variantGray && (
        <Image
          className="!w-[2.25rem] mb-[0.5rem] -scale-x-100"
          src={iconGray}
          alt=""
        />
      )} */}
    </div>
  );
}
